// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretsOutVerticalWithLine(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretsOutVerticalWithLine" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5 7.5H4.5L12.0004 1.5L19.5 7.5Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 16.5H19.5L11.9996 22.5L4.5 16.5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M4.5 10.5H19.5V13.5H4.5V10.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretsOutVerticalWithLine.js.map